__turbopack_context__.v({
  "card": "BlockSmallMediaWithText-module-scss-module___acxia__card",
  "cardInner": "BlockSmallMediaWithText-module-scss-module___acxia__cardInner",
  "cta": "BlockSmallMediaWithText-module-scss-module___acxia__cta",
  "eyebrow": "BlockSmallMediaWithText-module-scss-module___acxia__eyebrow",
  "fade-in": "BlockSmallMediaWithText-module-scss-module___acxia__fade-in",
  "flushBottom": "BlockSmallMediaWithText-module-scss-module___acxia__flushBottom",
  "flushTop": "BlockSmallMediaWithText-module-scss-module___acxia__flushTop",
  "image": "BlockSmallMediaWithText-module-scss-module___acxia__image",
  "imageLandscape": "BlockSmallMediaWithText-module-scss-module___acxia__imageLandscape",
  "imagePortrait": "BlockSmallMediaWithText-module-scss-module___acxia__imagePortrait",
  "imageRight": "BlockSmallMediaWithText-module-scss-module___acxia__imageRight",
  "inner": "BlockSmallMediaWithText-module-scss-module___acxia__inner",
  "makersReserve": "BlockSmallMediaWithText-module-scss-module___acxia__makersReserve",
  "media": "BlockSmallMediaWithText-module-scss-module___acxia__media",
  "parallaxImage": "BlockSmallMediaWithText-module-scss-module___acxia__parallaxImage",
  "root": "BlockSmallMediaWithText-module-scss-module___acxia__root",
  "textAlignLeft": "BlockSmallMediaWithText-module-scss-module___acxia__textAlignLeft",
  "videoPlayer": "BlockSmallMediaWithText-module-scss-module___acxia__videoPlayer",
  "videoPlayerAspect": "BlockSmallMediaWithText-module-scss-module___acxia__videoPlayerAspect",
});
